import { HOME_ROUTE } from '@/shared/constants/routes';

/**
 * Where a signed-in person lands: the overview, for one brand or several.
 * Staff land there too; the admin console is one click away in the sidebar.
 */
export function useHomeRoute(): string {
  return HOME_ROUTE;
}
